import React, { useState, useEffect } from 'react';
import bgVideo from '../assets/bg-vid1.mp4';
import { Sparkles, Zap, TrendingUp, ShieldCheck, ChevronLeft, ChevronRight } from 'lucide-react';
import Button from '../Ui/Button';
import { LandingPageProps } from '../types';
import { useNavigate } from 'react-router-dom';
import wehirePoster from '../assets/wehire-poster.png';
import mdProfile from '../assets/md_image.jpeg';

import b1 from '../assets/banner1.jpeg';
import b2 from '../assets/banner2.jpeg';
import b3 from '../assets/banner3.jpeg';
import b4 from '../assets/banner4.jpeg';
import b5 from '../assets/banner5.jpeg';
import b6 from '../assets/banner6.jpeg';
import b7 from '../assets/banner7.jpeg';

const bannerImages = [b1, b2, b3, b4, b5, b6, b7];
const LandingPage = ({ theme }: LandingPageProps) => {
    const navigate = useNavigate();
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const slideInterval = setInterval(() => {
            setCurrentSlide((prev) => (prev === bannerImages.length - 1? 0 : prev + 1));
        }, 2000);
        return () => clearInterval(slideInterval);
    }, []);

    const nextSlide = () => setCurrentSlide((prev) => (prev === bannerImages.length - 1? 0 : prev + 1));
    const prevSlide = () => setCurrentSlide((prev) => (prev === 0? bannerImages.length - 1 : prev - 1));

    return (
        <div className="flex flex-col min-h-screen overflow-x-hidden">

             {/* ===== FIXED HERO WITH VIDEO THEME ===== */}
             <section className="relative h-screen w-full overflow-hidden flex items-center pt-20">
                {/* VIDEO - NO -z-10 */}
                <video
                    src={bgVideo}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    className="absolute inset-0 w-full h-full object-cover"/>

                {/* OVERLAY - THEME GRADIENT */}
                <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-violet-900/30 to-black/60"></div>

                <div className="max-w-7xl mx-auto px-6 text-center lg:text-left flex flex-col lg:flex-row items-center gap-16 relative z-10 w-full">
                    <div className="lg:w-1/2 space-y-8">
                        <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full ${theme === 'light'? 'bg-violet-900/30 text-violet-300' : 'bg-violet-100 text-violet-700'} text-xs font-bold uppercase tracking-wider`}>
                            <Sparkles className="w-3 h-3"/>
                            <span>Staffing • HR • Real Estate</span>
                        </div>
                        <h1 className="text-4xl lg:text-6xl font-black tracking-tight leading-[1.1] text-white">
                            Empowering Talent, <br/>
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-400 via-fuchsia-400 to-pink-400 animate-gradient-x">
                                Enabling Growth.
                            </span>
                        </h1>
                        <p className="text-lg text-zinc-200 leading-relaxed max-w-lg mx-auto lg:mx-0 text-justify md:text-left">
                            We Hire Pvt Ltd is a leading provider of staffing and human resources management solutions, catering to the dynamic and diverse needs of businesses across India. From Payroll Management to Compliance and Real Estate Consultancy, we are your holistic growth partner.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                            <Button onClick={() => navigate('/apply')} className="py-4 px-8 text-lg shadow-violet-500/25">
                                Start Applying
                            </Button>

<Button onClick={() => navigate('/recruiters')} className="py-4 px-8 text-lg shadow-violet-500/25">
                                Partner With Us
                            </Button>

                        </div>
                    </div>
                </div>
            </section>

            {/* YOUR REST CODE SAME AS BEFORE - ABOUT, SERVICES, MD, BANNERS */}
            <div id="about" className="bg-[#F3F4F6]" style={{ paddingBottom: "100px", paddingLeft: "40px", paddingRight: "40px", paddingTop: "40px", scrollMarginTop: "90px" }}>

<p className="text-center pb-10">
  <span className="bg-gradient-to-r from-violet-600 to-fuchsia-500 text-white text-sm font-bold uppercase px-8 py-4 rounded-full shadow-lg underline">
    ABOUT US - Brief
  </span>
</p>
              <div className="flex flex-col md:flex-row gap-8 md:gap-16 justify-between text-[#111827] text-base font-normal leading-relaxed">
                <div className="md:w-[55%] left">
                  <p className="montserrat lg:text-[20px]" style={{ paddingTop: "0px" }}>We Hire Private Limited is a dynamic service organization headquarter in Kolkata, offering integrated solutions in manpower supply and real estate consultancy.</p>
                  <p className="mt-6 montserrat lg:text-[20px]">We started with a simple belief - every business needs two things to succeed: the right people and the right place. with deep industry expertise and a client-first approach, we bridge that gap efficiently and ethically.</p>
                  <p className="mt-6 montserrat lg:text-[20px]">We are not just a vendor; we are your growth partner. From providing skilled, semi-skilled, and unskilled manpower across industries to assisting you in buying, selling, leasing, and investing in commercial and residential properties, we deliver solutions that are timely, compliant, and cost-effective.</p>
                </div>
                <div className="md:w-[40%] flex flex-col gap-6 justify-start">
                  <p className="lg:text-[20px] montserrat" style={{ paddingTop: "0px" }}>Our Mission: To provide dependable manpower and transparent property solutions that drive client success.</p>
                  <p className="lg:text-[20px] montserrat">Our Vision: To be Eastern India's most trusted partner for workforce and workspace solutions.</p>
                </div>
              </div>
            </div>

<div className="w-screen relative left-1/2 -mx-[50vw] overflow-hidden bg-gray-100 py-2 mb-5">
</div>

<div id="service" className="bg-[#F3F4F6]" style={{paddingBottom: "100px",paddingLeft: "40px",paddingRight: "40px",paddingTop: "40px",scrollMarginTop: "90px"}}>
  <p className="text-center pb-10">
  <span className="bg-gradient-to-r from-violet-600 to-fuchsia-500 text-white text-sm font-bold uppercase px-8 py-4 rounded-full shadow-lg underline">
    SERVICES: WHAT WE DO
  </span>
</p>

<div className="flex flex-col md:flex-row gap-8 md:gap-16 justify-between text-[#111827] text-base font-normal leading-relaxed items-start">

    <div className="md:w-[55%] left flex flex-col gap-6 items-start self-start">
      <p className="lalezar text-[20px] lg:text-2xl font-bold text-[#111827] m-0 p-0 leading-none">
        1. MANPOWER SUPPLY SERVICES
      </p>

      <p className="montserrat lg:text-[20px] font-bold" style={{ paddingTop: "0px" }}>
        Your workforce is your strength. We provide trained and verified manpower tailored to your business needs.
      </p>

      <p className="mt-2 montserrat lg:text-[20px] flex gap-2">
        <span className="shrink-0">•</span>
        <span>Industrial & Factory Staffing: Machine operators, technicians, helpers, loaders.</span>
      </p>
      <p className="mt-2 montserrat lg:text-[20px] flex gap-2">
        <span className="shrink-0">•</span>
        <span>Corporate & Office Staffing: Admin staff, receptionists, data entry operators, accountants.</span>
      </p>
      <p className="mt-2 montserrat lg:text-[20px] flex gap-2">
        <span className="shrink-0">•</span>
        <span>Facility Management Staff: Security guards, housekeeping staff, pantry boys, electricians, plumbers.</span>
      </p>
      <p className="mt-2 montserrat lg:text-[20px] flex gap-2">
        <span className="shrink-0">•</span>
        <span>Temporary & Permanent Staffing: Short-term, long-term and permanent hiring solutions.</span>
      </p>
      <p className="mt-2 montserrat lg:text-[20px] flex gap-2">
        <span className="shrink-0">•</span>
        <span>Payroll Outsourcing & Compliance: We handle EPF, ESI, payroll, and labour law compliance.</span>
      </p>
      <p className="mt-2 montserrat lg:text-[20px] flex gap-2">
        <span className="shrink-0">•</span>
        <span>We Serve: Manufacturing, Logistics, Hospitality, Healthcare, Retail, Corporate Offices, Real Estate & Construction.</span>
      </p>
    </div>

    <div className="md:w-[40%] flex flex-col gap-6 items-start self-start">
      <p className="lalezar text-[20px] lg:text-2xl font-bold text-[#111827] m-0 p-0 leading-none">
        2. REAL ESTATE CONSULTANCY
      </p>

      <p className="montserrat lg:text-[20px] font-bold" style={{ paddingTop: "0px" }}>
        Making property transactions simple, secure and profitable.
      </p>
      <p className="montserrat lg:text-[20px] flex gap-2">
        <span className="shrink-0">•</span>
        <span>Commercial Real Estate: Office spaces, warehouses, shops, showrooms - Lease/Sale.</span>
      </p>
      <p className="montserrat lg:text-[20px] flex gap-2">
        <span className="shrink-0">•</span>
        <span>Residential Real Estate: Apartments, flats, villas, plots for buying & selling.</span>
      </p>
      <p className="montserrat lg:text-[20px] flex gap-2">
        <span className="shrink-0">•</span>
        <span>Industrial Property: Factory sheds, industrial land, godowns.</span>
      </p>
      <p className="montserrat lg:text-[20px] flex gap-2">
        <span className="shrink-0">•</span>
        <span>Investment Advisory: High-return property investment guidance.</span>
      </p>
      <p className="montserrat lg:text-[20px] flex gap-2">
        <span className="shrink-0">•</span>
        <span>Legal & Documentation Support: End-to-end assistance for verification, registration and agreements.</span>
      </p>
    </div>
  </div>
</div>
            {/* --- AUTO SLIDING BANNER GALLERY --- */}
{/* <section className="py-16 px-4 md:px-6 bg-violet-600"> */}
    <section className="py-16 px-4 md:px-6 bg-gradient-to-r from-[#7c3aed] to-[#c026d3]">

                <div className="max-w-5xl mx-auto">
                    <div className="text-center mb-10">
                        <h2 className={`text-3xl md:text-4xl font-black mb-4 ${theme === 'dark' ? 'text-white' : 'text-zinc-900'} underline`}>
                            Why You <span className="">Choose Us?</span>
                        </h2>
                    </div>

                    {/* Carousel Container */}
                    <div className="relative group w-full aspect-video md:aspect-[21/9] rounded-2xl overflow-hidden shadow-2xl border border-zinc-200 dark:border-zinc-800">
         
         {/* Images Slider */}
 <div className="w-full h-full flex transition-transform duration-700 ease-in-out" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                            {bannerImages.map((img, idx) => (
                                <div key={idx} className="min-w-full h-full relative">
                                    <img src={img} alt={`Banner ${idx + 1}`} className="w-full h-full object-cover"/>
                                    
                                    {/* Overlay Gradient for text readability if needed */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                </div>
                            ))}
                        </div>

                        {/* Controls (Arrows) */}
                        <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-black/50 text-white backdrop-blur-sm hover:bg-black/70 transition-all opacity-0 group-hover:opacity-100 focus:opacity-100">
                            <ChevronLeft className="w-6 h-6" />
                        </button>
                        <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-black/50 text-white backdrop-blur-sm hover:bg-black/70 transition-all opacity-0 group-hover:opacity-100 focus:opacity-100">
                            <ChevronRight className="w-6 h-6" />
                        </button>

                        {/* Dots Indicators */}
                        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                            {bannerImages.map((_, idx) => (
<button key={idx} onClick={() => setCurrentSlide(idx)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${currentSlide === idx ? 'bg-white w-6': 'bg-white/50 hover:bg-white/80'}`}/>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Services / How It Works */}
            <section className={`py-24 px-6 ${theme === 'dark' ? 'bg-black/20' : 'bg-zinc-50/50'}`}>
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-16">
                        <h2 className={`text-3xl md:text-5xl font-black mb-6 ${theme === 'light' ? 'text-white' : 'text-zinc-900'} underline`}>Why Choose Us?</h2>
                        <p className={`${theme === 'light' ? 'text-zinc-900' : 'text-zinc-900'} max-w-2xl mx-auto`}> We deliver a comprehensive bouquet of services tailored to support businesses, institutions, and surrounding societies.
                        </p>
                    </div>

<div className="grid md:grid-cols-3 gap-8">
  {[
    { icon: Zap, title: "Staffing & Payroll", desc: "Reliable technical and non-technical manpower solutions with complete payroll management." },
    { icon: TrendingUp, title: "Training & Development", desc: "Capability building and HR consulting to help organizations achieve their goals." },
    { icon: ShieldCheck, title: "Compliance & Safety", desc: "Full compliance management and background verification for peace of mind." }
  ].map((item, idx) => (
    <div key={idx} className="group bg-gradient-to-r from-violet-600 to-fuchsia-500 border-transparent p-8 rounded-3xl shadow-lg hover:shadow-xl hover:shadow-violet-500/20 border transition-all duration-300 hover:-translate-y-2">
      
      <div className="w-14 h-14 bg-white/20 text-white rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
        <item.icon className="w-7 h-7" />
      </div>
      <h3 className="text-xl font-bold mb-3 text-white">{item.title}</h3>
      <p className="text-white/90 leading-relaxed">{item.desc}</p>
    </div>
  ))}
</div>


<div className="grid md:grid-cols-3 gap-8 mt-8">
  {[
    { icon: Zap, title: "Dual Expertise", desc: "One company for your manpower and property needs." },
    { icon: TrendingUp, title: "Verified & Trained Talent", desc: "Thorough background verification and skill screening." },
    { icon: ShieldCheck, title: "Transparent Dealing", desc: "No hidden costs, clear documentation, honest advice." }
  ].map((item, idx) => (
    <div key={idx} className="group bg-gradient-to-r from-violet-600 to-fuchsia-500 border-transparent p-8 rounded-3xl shadow-lg hover:shadow-xl hover:shadow-violet-500/20 border transition-all duration-300 hover:-translate-y-2">
      <div className="w-14 h-14 bg-white/20 text-white rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
        <item.icon className="w-7 h-7" />
      </div>
      <h3 className="text-xl font-bold mb-3 text-white">{item.title}</h3>
      <p className="text-white/90 leading-relaxed">{item.desc}</p>
    </div>
  ))}
</div>


<div className="grid md:grid-cols-3 gap-8 mt-8">
  {[
    { icon: Zap, title: "Pan-India Network", desc: "Strong database of candidates and properties." },
    { icon: TrendingUp, title: "Statutory Compliant", desc: "100% compliant with all labour laws and property regulations." },
    { icon: ShieldCheck, title: "Quick Turnaround", desc: "We understand urgency. We deliver fast." }
  ].map((item, idx) => (
    <div key={idx} className="group bg-gradient-to-r from-violet-600 to-fuchsia-500 border-transparent p-8 rounded-3xl shadow-lg hover:shadow-xl hover:shadow-violet-500/20 border transition-all duration-300 hover:-translate-y-2">
      <div className="w-14 h-14 bg-white/20 text-white rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
        <item.icon className="w-7 h-7" />
      </div>
      <h3 className="text-xl font-bold mb-3 text-white">{item.title}</h3>
      <p className="text-white/90 leading-relaxed">{item.desc}</p>
    </div>
  ))}
</div>

                </div>
            </section>
        </div>
    );
};

export default LandingPage;
